import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

// MuscleWiki media (video + poster) requires an API key header browsers can't send, so it 404s/
// blue-question-marks when hot-linked. Route any MuscleWiki media through our backend proxy.
export const exerciseMedia = (url) =>
  url && /musclewiki\.com\//i.test(url) ? `${API}/media/exercise?u=${encodeURIComponent(url)}` : url;

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('stp_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('stp_token');
      localStorage.removeItem('stp_user');
      if (!window.location.pathname.startsWith('/login')) window.location.href = '/login';
    }
    return Promise.reject(err);
  },
);

// Triggers the background calendar sync and polls /calendar/sync/status until it finishes.
// Resolves with { ok, imported, pushed, updated_from_google } or throws with a message.
export async function syncCalendar({ intervalMs = 2000, timeoutMs = 120000 } = {}) {
  await api.post('/calendar/sync');
  const deadline = Date.now() + timeoutMs;
  while (Date.now() < deadline) {
    await new Promise((res) => setTimeout(res, intervalMs));
    const { data } = await api.get('/calendar/sync/status');
    if (!data.syncing) {
      if (data.error) throw new Error(data.error);
      return data.last_result || { ok: true, imported: 0, pushed: 0 };
    }
  }
  throw new Error('Sync timed out');
}
